import React, { useState } from "react";
import { ClickAwayListener, Stack, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";

import { HubButton, HubHookFormInput } from "../../components";
import { usePutAdminQuickUpdateWorkOrder } from "../../hooks/react-query/useWorkOrderData";
import { StyledBox } from "./styles";

const EstimatedCompletedCell = ({ item }) => {
  const [editing, setEditing] = useState(false);
  const [hovered, setHovered] = useState(false);
  const initial = item.estimatedCompleted ?? item.quantity ?? 0;
  const methods = useForm({ defaultValues: { estimatedCompleted: initial } });
  const { mutate, isLoading } = usePutAdminQuickUpdateWorkOrder();

  const commit = (raw) => {
    let next = Number(raw);
    if (!Number.isFinite(next) || next < 0) next = 0;
    const qty = Number(item.quantity);
    if (Number.isFinite(qty) && next > qty) next = qty;
    if (next === initial) {
      setEditing(false);
      return;
    }
    mutate(
      { id: item.workOrder, estimatedCompleted: next },
      { onSettled: () => setEditing(false) },
    );
  };

  if (editing) {
    return (
      <ClickAwayListener onClickAway={() => setEditing(false)}>
        <StyledBox onClick={(e) => e.stopPropagation()}>
          <FormProvider {...methods}>
            <HubHookFormInput
              name="estimatedCompleted"
              defaultValue={initial}
              isNumber
              disabled={isLoading}
              onBlur={(_, value) => commit(value)}
              autoFocus
              disableHelperText
            />
          </FormProvider>
        </StyledBox>
      </ClickAwayListener>
    );
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="10px"
      width="120px"
      height="18px"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={(e) => {
        e.stopPropagation();
        setEditing(true);
      }}
    >
      <Typography variant="caption" fontSize={11}>
        {initial}
      </Typography>
      <HubButton
        variant="text"
        icon="Edit"
        iconProps={{ size: "12px" }}
        sx={{ color: hovered ? "hubColors.greyDark" : "hubColors.white" }}
        size="xsmall"
      />
    </Stack>
  );
};

export default EstimatedCompletedCell;
